import api from "../../apiClient"

/**
 * admin/User
 */

export const getUserList = async () => {
  console.log(`@getUserList`)
  const response = await api.get("/user/list")
  return response.data
}

export const modifyUserGrade = async (data) => {
  console.log(`@modifyUserGrade`)
    const response = await api.put("/user/permission", data);
    return response.data
}